import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import LoadingCube from 'sub_components/Common/LoadingCube';
import { MicrosoftApi } from 'services/microsoft';
import { BloxButton } from 'styled_components/Common/BloxButton';
import format from 'date-fns/format';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';

const EventDetails = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 280px;
	color: ${props => props.theme.defaultFontColor};
	.loading-cube {
		width: 100%;
	}
	.ScrollbarsCustom-Track {
		right: -10px !important;
		top: 0px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.storage} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}
	.main-display {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		.row {
			margin-bottom: 10px;
			.label {
				margin-bottom: 5px;
			}
		}
		.event-wrapper {
			width: 100%;

			.dates {
				display: flex;
				.row {
					flex: 1;
				}
			}
			.edit-event-section {
				display: flex;
				justify-content: space-evenly;
				width: 100%;
				margin-bottom: 10px;
			}
			.event-details {
				.row {
					.value {
						line-height: 15px;
					}
				}
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 305px;
		.main-display {
			width: 100%;

			.event-details {
				.row {
					.value {
						line-height: 15px;
					}
				}
			}
		}
		.ScrollbarsCustom-Track {
			right: -10px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.storage} !important;
			width: 8px !important;
		}

		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 8px !important;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 535px;
		.main-display {
			width: 100%;

			.row {
				margin-bottom: 20px;
				.label {
					margin-bottom: 10px;
				}
			}
			.event-details {
				.row {
					.value {
						line-height: 21px !important;
					}
				}
			}
		}
		.ScrollbarsCustom-Track {
			right: -10px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.storage} !important;
			width: 10px !important;
		}
		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 10px !important;
		}
	}
`;

export const EventDetail = ({
	eventId,
	datacenter,
	cancelEvent,
	toggleUpdateModal,
	setEventDetails,
	showUpdateModal,
}) => {
	const [event, setEvent] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	useEffect(() => {
		const params = {
			id: eventId,
			datacenter,
		};
		MicrosoftApi.getEvent(params)
			.then(response => {
				const validResponse = response.status === 200 && response.data;

				if (validResponse) {
					setEvent(response.data?.event);
					if (setEventDetails) {
						setEventDetails(response.data?.event);
					}
					setIsLoading(false);
				} else {
					setIsLoading(false);
					//this.setState({ error: 'Error getting badge details' });
				}
			})
			.catch(() => {
				setIsLoading(false);
			});
	}, [setEvent, showUpdateModal]);

	return (
		<EventDetails>
			{isLoading && <LoadingCube />}
			<ScrollView>
				<div className='main-display'>
					{event && event.length === 0 && !isLoading && (
						<div className='body10'>No scheduled event.</div>
					)}
					{!event && !isLoading && <div className='body10'>No scheduled event.</div>}
					{event && event.length !== 0 && !isLoading && (
						<div className='event-wrapper'>
							<div className='event-details'>
								<div className='dates'>
									<div className='row'>
										<div className='label section-label'>Start Date : </div>
										<div className='value footer20'>
											{format(new Date(event?.startDateTime?.dateTime), 'MM/dd/yyyy hh:mm a')}
										</div>
									</div>
									<div className='row'>
										<div className='label section-label'> End Date : </div>
										<div className='value footer20'>
											{format(new Date(event?.endDateTime?.dateTime), 'MM/dd/yyyy hh:mm a')}
										</div>
									</div>
								</div>
								<div className='row'>
									<div className='label section-label'>Subject </div>
									<div className='value footer20'>{event?.subject} </div>
								</div>
								<div className='row'>
									<div className='label section-label'>Description </div>
									<div className='value footer20'>{event?.bodyPreview} </div>
								</div>
								<div className='row'>
									<div className='label section-label'>Attendees</div>
									{event?.attendees &&
										event.attendees.map(a => (
											<div className='value footer20'>{a.emailAddress?.address} </div>
										))}
								</div>
							</div>

							<div className='edit-event-section'>
								<div className='update-event-button'>
									<BloxButton
										className='update-event buttons41'
										text='UPDATE'
										module='support'
										enabled={true}
										onClick={toggleUpdateModal}
										cypressId='update-event'
									/>
								</div>
								<div className='cancel-event-button'>
									<BloxButton
										className=' cancel-event buttons41'
										text='CANCEL'
										module='support'
										enabled={true}
										onClick={cancelEvent}
										cypressId='cancel-event'
									/>
								</div>
							</div>
						</div>
					)}
				</div>
			</ScrollView>
		</EventDetails>
	);
};
// LargeInfoDisplay.propTypes = {
// 	type: string.isRequired,
// };

// LargeInfoDisplay.defaultProps = {};
